import Box from '@mui/material/Box';
import Input from '@mui/material/Input';
import FilterUsers from './FilterUsers/FilterUsers';
import useFetchData from '../../../../../hooks/useFetchData';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Badge from '@mui/material/Badge';
import GroupIcon from '@mui/icons-material/Group';
import TextNotAssigned from '../../../../text/TextNotAssigned';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ASSESSMENT_TYPE_CUSTOM, ASSESSMENT_TYPE_STANDARD } from '../../constants/typeAssessment';
import './ReviewersPanel.css';

const ReviewerUsersPanelHeader = ({
  handleClassSearch,
  handleUserSearch,
  classInputSearch,
  userInputSearch,
  users = [],
  reviewers = [],
  selectedUserIds = [],
  setSelectedUserIds,
  assessmentType = ASSESSMENT_TYPE_STANDARD
}) => {
  const { isLoading: isLoadingRoles, data: dataRoles = [] } = useFetchData('roles/standard');
  const [filteredRoles, setFilteredRoles] = useState([]);
  const [checkAllUsers, setCheckAllUsers] = useState(false);
  const [enableUserSearch, setEnableUserSearch] = useState(false);
  const filter = useSelector((state) => state?.filter?.assessmentReviewers?.filter || {});
  const open = useSelector((state) => state?.filter?.assessmentReviewers?.open || false);
  const userRoles = useSelector((state) => state?.session?.user?.roles || []);

  useEffect(() => {
    if (dataRoles && dataRoles?.length > 0) {
      const isMaestroUser = userRoles.find((role) => role?.id === 'Maestro');
      const notAllowedRoles = ['Student', 'Parent'];

      if (!isMaestroUser) {
        notAllowedRoles.push('Maestro');
      }

      const filteredRoles = dataRoles.filter((role) => !notAllowedRoles.includes(role?.id));
      setFilteredRoles(filteredRoles);
    }
  }, [dataRoles]);

  useEffect(() => {
    if (checkAllUsers) {
      const selectedUserCodes = users?.map((user) => user?.code);
      setSelectedUserIds(selectedUserCodes);
    } else {
      setSelectedUserIds([]);
    }
  }, [checkAllUsers]);

  useEffect(() => {
    if (filter && Object.keys(filter).length > 0 && !open) {
      setEnableUserSearch(true);
    } else {
      setEnableUserSearch(false);
      handleUserSearch({ target: { value: '' } });
      setCheckAllUsers(false);
    }
  }, [filter]);

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
        display: 'flex'
      }}
    >
      <Box sx={{ width: '100%', backgroundColor: '#fff' }}>
        <Box className='reviewers-panel__search '>
          <Box className='reviewers-panel__search-container'>
            <Box>
              <FilterUsers
                disabled={isLoadingRoles}
                dataYears={[]}
                dataRoles={filteredRoles ?? []}
                isLoadingRoles={isLoadingRoles}
                isLoadingYears={false}
                module='assessmentReviewers'
              />
            </Box>
            <div
              className='m-l-20 box-end reviewers-panel__search-input my-4 relative'
              style={{ _display: 'flex', alignItems: 'center' }}
            >
              <Input
                type='text'
                value={userInputSearch}
                onChange={handleUserSearch}
                sx={{ width: '60%' }}
                placeholder='Search users by code or name'
                disabled={!enableUserSearch || users?.length === 0}
              />
              <FontAwesomeIcon icon='search' style={{ marginRight: 'rem' }} />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkAllUsers}
                    disabled={isLoadingRoles || users?.length === 0 || !enableUserSearch}
                    onClick={(e) => setCheckAllUsers(e.target.checked)}
                  />
                }
                label={`Select all`}
                labelPlacement='start'
                style={{ width: '20%' }}
              />
              <Badge
                badgeContent={selectedUserIds?.length || 0}
                color='primary'
                style={{ marginLeft: '1.5rem' }}
              >
                <GroupIcon color='action' />
              </Badge>
            </div>
          </Box>
        </Box>
        <TextNotAssigned
          text={`Only checked users can be dragged into the ${
            ASSESSMENT_TYPE_CUSTOM === assessmentType ? 'reviewers panel' : 'classes'
          }.`}
          size='md'
          className='px-6'
        />
      </Box>
    </Box>
  );
};

export default ReviewerUsersPanelHeader;
